/* eslint-disable */
// src/utils/navigateAddVisitTransactionHelper.js

import { rememberVisitDraft } from "utils/visitDraftSession";

export async function navigateAddVisitTransactionHelper(
  navigate,
  local,
  profitPercentages,
  localMachineDetails,
  VisitTransactionService,
  options = {}
) {
  if (!local?.Id) return null;

  const draft = await VisitTransactionService.startOrResumeCollectionDraft(local.Id);
  const visitWithCollectionId = Number(
    draft?.visitWithCollectionId ?? draft?.visitId ?? 0
  );

  if (!visitWithCollectionId) {
    throw new Error("No se pudo resolver el borrador de recaudación.");
  }

  rememberVisitDraft(local.Id, visitWithCollectionId);

  navigate(`/local/${local.Id}/visitMachine/nuevo`, {
    state: {
      local,
      profitPercentages,
      localMachineDetails,
      visitWithCollectionId,
      visitDateTime: draft?.visitDateTime || null,
      bcVisitId: visitWithCollectionId,
      ...(options.state || {}),
    },
  });

  return draft;
}
